import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class IndicadoresService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService) { }

  public getIndicadoresValues(anio:string, zona:string, mes:string, tipo:string): Promise<any> {
    const userid = sessionStorage.getItem('userid');
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
    anio = anio === "0" ? "" : anio;
    zona = zona === "0" ? "" : zona;
    mes = mes === "0" ? "" : mes;
    tipo = tipo === "0" ? "" : tipo;
    return this.http.get(`${this.configService.API_URL}/indicadores/values?user=${userid}&anio=${anio}&zona=${zona}&mes=${mes}&tipo=${tipo}`, { headers }).toPromise();
  }
}
